/** 이벤트 실시간(STOMP) 계약. AsyncAPI 가 REST 와 별도 문서다 — 필드가 다르다. */
import type { FileResponse } from "../files/types";
import type { SiteRegion } from "../sites/types";
import type { EventCategory, EventSeverity, EventSource, EventType } from "./types";

// `uuid`·`region` 이 선택인 이유 — cctv-ai 지면이 REST `/events` 목록과 실시간 메시지를
// 한 배열에 섞어 쓰는데 REST 쪽 `site` 에는 `uuid` 가 없다.
export interface EventSiteInfo {
  id: number;
  name: string;
  region?: SiteRegion | null;
  uuid?: string;
}

// payload 를 화면에 뿌리기 위한 표시 정보. payload 가 없으면 빈 목록.
export interface EventMetadataField {
  key: string;
  label: string;
  type: string;
  unit?: string | null;
}

// `category` 는 DETECTION|SAFETY 를 가르는 유일한 기준이라 없으면 권한 필터와 cctv-ai
// 목록이 둘 다 어긋난다. `severity` 는 AsyncAPI 상 nullable 이지만 실제로는 항상 채워져
// 온다(서버 확인).
export interface EventMessage {
  id: number;
  eventId: string;
  name: string;
  type: EventType;
  category: EventCategory;
  timestamp: string;
  severity?: EventSeverity | null;
  site: EventSiteInfo;
  path?: string | null;
  trackId?: number | null;
  confidence?: number | null;
  snapshot?: FileResponse;
  video?: FileResponse;
  source?: EventSource | null;
  deviceId?: string | null;
  lat?: number | null;
  lon?: number | null;
  alt?: number | null;
  payload?: Record<string, unknown>;
  metadata?: EventMetadataField[];
}

/** @deprecated `EventMessage` 를 쓸 것. cctv-ai 지면이 아직 이 이름을 쓴다. */
export type StompEventResponse = EventMessage;

export type StompEventType = EventType;
export type StompEventCategory = EventCategory;

/**
 * 구독 destination. 서버가 정하는 값이라 계약 쪽에 둔다 — STOMP 는 없는 목적지 구독도
 * 조용히 성공하므로, 서버가 옮겼을 때 한쪽만 고치면 에러 없이 실시간이 죽는다.
 * `/user/queue` 는 세션 Principal 로 수신자를 고른다 — 인증이 안 서면 구독은 되는데
 * 메시지가 안 온다.
 */
export const STOMP_DESTINATIONS = {
  events: "/user/queue/events",
  eventVideos: "/user/queue/event-videos",
} as const;

/**
 * STOMP 엔드포인트 경로. 스킴·호스트를 붙여 `wss://…/api/stomp/platform` 을 만드는 것은
 * 전송 쪽 일이라 앱이 한다 — 이 패키지는 경로만 안다.
 */
export const STOMP_ENDPOINT = "/stomp/platform";
